import {buildApi} from "@/libs/api.request";
import axios from "@/libs/api.request";

export const apis = buildApi({
  get: ['/tracker/Trace/dduList&list',],
  post: ['/tracker/Trace/saveDduCollection', '/tracker/Trace/batchSaveTrace']
})

export const uploadCollection = (data) => {
  return axios.request({
    url: "/tracker/Trace/saveDduTracker",
    method: "post",
    data
  });
}
